<template id="create-model">
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" :style="{height:ModalHeight+'px'}">
          <div class="steps-nav-wrapper">
            <div class="steps-nav">
              <span class="steps-count" v-bind:class="{'active':(step == 1)}">1</span>
              <span class="steps-count" v-bind:class="{'active':(step == 2)}">2</span>
              <span class="steps-count" v-bind:class="{'active':(step == 3)}">3</span>
              <span v-if="modelType != 'view'" class="steps-count" v-bind:class="{'active':(step == 4)}">4</span>
            </div>
            <h3 class="steps-heading clearfix">
              <span v-if="modelType == 'create'">Create Model</span>
              <span v-else-if="modelType == 'view'">Model Configuration Details : {{ViewModel.name}}</span>
              <a class="close-btn" @click="$emit('close')">
                <i class="fa fa-times" aria-hidden="true"></i>
              </a>
            </h3>
          </div>
          <div class="steps-content">
            <!-- <div><button v-on:click="getObject">JSONObject</button></div> -->
            <div class="form-wrapper">
              <keep-alive>
                <component v-bind:is="ActiveComponent" :inputData="Input" :createdObject="CreatedModel" :viewObject="ViewModel" :modelType="modelType" :validate="Validate" @stepValidate="stepsValidations(step)"></component>
              </keep-alive>
            </div>
            <div class="fluid-container text-right">
              <div v-if="step > 1" class="btn-wrap">
                <button class="btn btn-primary" v-on:click="backStep">Back</button>
              </div>
              <div v-if="step < steps" class="btn-wrap">
                <button class="btn btn-primary" v-on:click="nextStep">Next</button>
              </div>
              <div v-if="step == steps && modelType != 'view'" class="btn-wrap">
                <button class="btn btn-primary" v-on:click="createModel">Create Model</button>
              </div>
              <div v-if="step == 3 && modelType == 'view'" class="btn-wrap">
                <button class="btn btn-primary" v-on:click="$router.push('/report')">View Report</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import StepOne from './Model-one.vue'
import StepTwo from './Model-two.vue'
import StepThree from './Model-three.vue'
import StepFour from './Model-four.vue'
import Jquery from 'jquery'
import Simplert from 'vue2-simplert'
var $ = Jquery
export default {
  components: {
    'step1': StepOne,
    'step2': StepTwo,
    'step3': StepThree,
    'step4': StepFour,
    Simplert
  },
  props: ['modelType'],
  data () {
    return {
      Input: [],
      ActiveComponent: 'step1',
      step: 1,
      steps: 4,
      ModalHeight: window.outerHeight - 180,
      CreatedModel: {
        'market': '',
        'name': '',
        base_sales_flag: false,
        'country': '',
        'KPI': '',
        'user_id': window.localStorage.getItem('user'),
        'nests': ['Sales'],
        'initial_annual_spend': {
          'is-table': true,
          'table-data': {
            'Annual spend': [],
            'Channels': []
          }
        },
        'total_weekly_sales': {
          'is-table': true,
          'table-data': {
            'week_no': [],
            'weekly_base_sales': []
          }
        },
        'ccs': {
          'is-table': true,
          'table-data': {
            'Channels': [],
            'Direct Reach': []
          }
        },
        'size_propensity': {
          'is-table': true,
          'table-data': {
            'Size': [
              'Size'
            ],
            'Direct Reach': []
          }
        }
      },
      Validate: {
        'step1': true,
        'step2': true,
        'step3': true,
        'step4': true
      },
      ccsRemove: true,
      ViewModel: ''
    }
  },
  created () {
    var self = this
    if (this.modelType === 'create') {
      Jquery('.spinner').show()
      Jquery('.spinner .loadingtext').text('fetching available countries and categories...')
      setTimeout(() => {
        Jquery('.spinner .loadingtext').text('almost done!')
      }, 2000)
      $.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/VelocityGetLookupTable',
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        beforeSend: function () {
          self.loadingtext = 'processing...'
          $('.spinner').show()
        },
        complete: function () {
          $('.spinner').hide()
        },
        success: function (data) {
          self.Input = JSON.parse(data['lookup-data'])
          return data
          // self.displaypopup()
        },
        error: function (data, error) {
          console.log(error)
          $('.spinner').hide()
          self.errorPopup()
        }
      })
      // fetch(window.localStorage.getItem('ApiURL') + '/VelocityGetLookupTable', {
      //   method: 'POST',
      //   async: true,
      //   contentType: 'application/json',
      //   headers: {'x-api-key': window.localStorage.getItem('XpiKey')}
      // })
      // .then(response => response.json())
      // .then((data) => {
      //   Jquery('.spinner').hide()
      //   this.Input = JSON.parse(data['lookup-data'])
      // })
    } else if (this.modelType === 'view') {
      this.steps = 3
      // var jobId = window.localStorage.getItem('JobId')
      // jobId = jobId.replace('job-id=', '')
      this.getreadonlyform()
    }
  },
  methods: {
    errorPopup () {
      let err = {
        title: 'Data Error',
        message: ' ',
        type: 'error',
        customClass: 'error'
      }
      this.$refs.simplert.openSimplert(err)
    },
    getreadonlyform () {
      var jobId = window.localStorage.getItem('JobId')
      jobId = jobId.replace('job-id=', '')
      var ddta = { 'job-id': jobId, 'user-id': window.localStorage.getItem('user') }
      //         fetch(window.localStorage.getItem('ApiURL') + '/getorupdatemodel', {
      //   method: 'POST',
      //   body: ddta,
      //   async: true,
      //   contentType: 'application/json',
      //   headers: {
      //     'x-api-key': window.localStorage.getItem('XpiKey')
      //   }
      // })
      // .then(response => response.json())
      // .then((data) => {
      //   Jquery('.spinner').hide()
      //   this.ViewModel = data['output']
      // })
      var self = this
      Jquery.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/getorupdatemodel',
        data: JSON.stringify(ddta),
        async: true,
        contentType: 'application/json',
        headers: { 'x-api-key': window.localStorage.getItem('XpiKey') },
        beforeSend: function () {
          Jquery('.spinner').show()
          self.loadingtext = 'fetching your models...'
          setTimeout(() => {
            self.loadingtext = 'almost done!'
          }, 2000)
        },
        complete: function () {
          Jquery('.spinner').hide()
        },
        success: function (data) {
          self.ViewModel = data['output']
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          self.errorPopup()
          // self.displaydownloadError()
        }
      })
    },
    getObject () {
      console.log(this.CreatedModel)
    },
    nextStep () {
      if (this.modelType !== 'view') {
        if (this.validateFirstStep() && this.step === 1) {
          this.ActiveComponent = 'step' + ++this.step
        } else if (this.validateSecondStep() && this.step === 2) {
          this.ActiveComponent = 'step' + ++this.step
        } else if (this.validateThirdStep() && this.step === 3) {
          this.ActiveComponent = 'step' + ++this.step
        } else {
          return false
        }
      } else {
        this.ActiveComponent = 'step' + ++this.step
      }
    },
    backStep () {
      this.ActiveComponent = 'step' + --this.step
    },
    createModel () {
      if (this.validateFourthStep() && this.step === 4) {
        if (this.ccsRemove) {
          delete this.CreatedModel.ccs
          delete this.CreatedModel.size_propensity
        }
        Jquery.ajax({
          type: 'POST',
          url: window.localStorage.getItem('ApiURL') + '/VelocityCreateModel',
          data: { 'data': JSON.stringify(this.CreatedModel) },
          async: true,
          contentType: 'application/json',
          headers: {
            'x-api-key': window.localStorage.getItem('XpiKey')
          },
          beforeSend: () => {
            Jquery('.spinner').show()
            Jquery('.spinner .loadingtext').text('setting up model framework...')
            setTimeout(() => {
              Jquery('.spinner .loadingtext').text('calculating ecosystem...')
            }, 2000)
            setTimeout(() => {
              Jquery('.spinner .loadingtext').text('almost done!')
            }, 4000)
          },
          complete: () => {
            Jquery('.spinner').hide()
          },
          success: (data) => {
            data = data['output']
            data = JSON.parse(data)
            let jobid = 'job-id=' + data.job_id
            window.localStorage.setItem('JobId', jobid)
            this.$emit('close')
            this.$emit('openModal')
          },
          error: (data, error) => {
            console.log(error)
          }
        })
      }
    },
    stepsValidations (step) {
      if (step === 1) {
        this.validateFirstStep()
      } else if (step === 2) {
        this.validateSecondStep()
      } else if (step === 3) {
        this.validateThirdStep()
      } else if (step === 4) {
        this.validateFourthStep()
      }
    },
    validateFirstStep () {
      if (
        this.CreatedModel.name !== '' &&
        this.CreatedModel.country !== '' &&
        this.CreatedModel.market !== '' &&
        this.CreatedModel.KPI !== '' &&
        this.CreatedModel.nests.length > 1 &&
        this.CreatedModel.initial_annual_spend['table-data']['Channels'].length > 0
      ) {
        this.Validate['step1'] = true
        return true
      } else {
        this.Validate['step1'] = false
        return false
      }
    },
    validateSecondStep () {
      let weekSalesObj = this.CreatedModel.total_weekly_sales['table-data'].weekly_base_sales
      this.Validate['step2'] = true
      for (let week in weekSalesObj) {
        if (weekSalesObj[week] === '' || isNaN(weekSalesObj[week])) {
          this.Validate['step2'] = false
        }
      }
      if (this.Validate['step2']) {
        this.Validate['step2'] = true
        return true
      } else {
        this.Validate['step2'] = false
        return false
      }
    },
    validateThirdStep () {
      let paidMediaObj = this.CreatedModel.initial_annual_spend['table-data']['Annual spend']
      this.Validate['step3'] = true
      if (paidMediaObj.length === this.CreatedModel.initial_annual_spend['table-data']['Channels'].length) {
        for (let spend in paidMediaObj) {
          if (paidMediaObj[spend] === '' || isNaN(paidMediaObj[spend])) {
            this.Validate['step3'] = false
          }
        }
      } else {
        this.Validate['step3'] = false
      }
      if (this.Validate['step3']) {
        this.Validate['step3'] = true
        return true
      } else {
        this.Validate['step3'] = false
        return false
      }
    },
    validateFourthStep () {
      let ccsRichObj = this.CreatedModel.ccs['table-data']
      let ccsSizeObj = this.CreatedModel.size_propensity['table-data']
      this.Validate['step4'] = true
      this.ccsRemove = true
      for (let ccs in ccsRichObj) {
        if (ccsRichObj[ccs].length > 0 && ccs !== 'Channels') {
          this.ccsRemove = false
        }
      }
      for (let size in ccsSizeObj) {
        if (ccsSizeObj[size].length > 0 && size !== 'Size') {
          this.ccsRemove = false
        }
      }
      if (!this.ccsRemove) {
        for (let ccsVal in ccsRichObj) {
          for (let val in ccsRichObj[ccsVal]) {
            if ((ccsRichObj[ccsVal][val] === '' || isNaN(ccsRichObj[ccsVal][val]) || ccsRichObj[ccsVal].length !== ccsRichObj['Channels'].length) && ccsVal !== 'Channels') {
              this.Validate['step4'] = false
            }
          }
        }
        for (let sizeVal in ccsSizeObj) {
          for (let val in ccsSizeObj[sizeVal]) {
            if ((ccsSizeObj[sizeVal][val] === '' || isNaN(ccsSizeObj[sizeVal][val]) || ccsSizeObj[sizeVal].length !== ccsSizeObj['Size'].length) && sizeVal !== 'Size') {
              this.Validate['step4'] = false
            }
          }
        }
      }
      if (this.Validate['step4']) {
        this.Validate['step4'] = true
        return true
      } else {
        this.Validate['step4'] = false
        return false
      }
    }
  },
  destroyed () {
    this.CreatedModel = []
    this.ViewModel = ''
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang='scss'>
.steps-nav-wrapper {
  padding: 20px 25px 0;
  position: absolute;
  width: 76%;
  left: 12%;
  background: #fff;
  top: 50px;
  z-index: 9999;
}
.steps-count {
  background-color: #a8a9ad;
  border-radius: 100%;
  color: #fff;
  width: 37px;
  height: 37px;
  font: bold 22px/35px 'century gothic';
  text-align: center;
  display: inline-block;
  position: relative;
  z-index: 1;
  cursor: default;
  border: 1px solid #ccc;
}
.steps-count.active {
  background-color: #f78620;
  border: 1px solid #fff203;
  text-shadow: 2px 1px 0px rgba(0, 0, 0, 0.4);
}
.steps-nav {
  position: relative;
  text-align: justify;
  height: 37px;
}
.steps-nav:after {
  content: '';
  display: inline-block;
  width: 100%;
}
.steps-nav:before {
  display: block;
  content: '';
  width: 100%;
  height: 1px;
  position: absolute;
  top: 50%;
  left: 0;
  background: #ffd000;
  margin-top: -1px;
  z-index: 0;
}
.steps-heading {
  border-bottom: 1px solid #000;
  font: bold 16px 'Verdana';
  padding-bottom: 10px;
}
.steps-heading a.close-btn {
  float: right;
  padding: 0 5px;
  color: #000;
  cursor: pointer;
}
.steps-content {
  padding: 10px 25px;
  margin-top: 120px;
}
.handsontable td.area,
.handsontable td.esheetclass {
  text-align: left;
}
.handsontable tr td.esheetclass.createmodel {
  text-align: center !important;
}
.handsontable td.esheetclass.htDimmed.createmodel {
  text-align: left !important;
}
.handsontable .createtable thead th .relative {
  padding: 5px;
}
.handsontable .createtable td.esheetclass.htDimmed {
  padding: 4px 4px 4px 15px;
}
.form-wrapper ol {
  margin: 0 0 0 14px;
  padding: 0;
}
.createtable .htDimmed.view-only {
  background: #eee !important;
  color: #555 !important;
  font-weight: normal;
  border-color: #d2d6de;
}
.createtable .htDimmed.view-only:first-child,
.createtable.paid-media tr:last-child .htDimmed.view-only:last-child {
  background-color: #000 !important;
  color: #989595 !important;
  font-weight: bold;
}
.form-wrapper .control-label {
  text-align: left;
  display: inline-block;
  vertical-align: middle;
  width: 15%;
  font-weight: normal;
}
.form-wrapper .form-group {
  margin-bottom: 30px;
}
.form-group .input-box {
  display: inline-block;
  vertical-align: middle;
  min-width: 170px;
}
.form-group .input-box select {
  background-color: #000;
  color: #fff;
  border-color: #000;
}
.form-group .input-box select[disabled='disabled'] {
  opacity: 0.6;
}
.invalid-field .input-box,
.invalid-field .error-msg {
  color: #ff0000;
}
.invalid-field .input-box input,
.invalid-field .input-box select,
.invalid-field .input-box .multiselect {
  border: 1px solid #ff0000;
}
.invalid-field .input-box .multiselect input {
  border: none;
}
.error-msg {
  display: none;
}
.invalid-field .error-msg {
  display: block;
}
.form-group .input-box input,
.form-group .input-box select {
  width: 170px;
  display: inline-block;
  margin-right: 10px;
  border-radius: 6px;
  border-width: 2px;
  padding: 8px 12px;
  height: auto;
}

.btn-wrap {
  display: inline-block;
}
.btn.btn-primary {
  background: #000;
  border-radius: 6px;
  font-weight: bold;
  font-size: 15px;
  width: 120px;
  border-color: #000;
  margin-right: 15px;
}
.form-group {
  .multiselect {
    max-width: 700px;
    input,
    .multiselect__single {
      padding: 0;
      width: 70px;
      margin: 5px 4px 5px 44px;
      border-width: 1px;
      position: absolute;
      right: 0;
      top: 9px;
      cursor: pointer;
    }
    .multiselect__select {
      right: 85px;
      top: 9px;
      padding: 0;
      width: auto;
      height: auto;
      &:before {
        content: '+';
        background: #ccc;
        width: 35px;
        height: 30px;
        border: 0;
        margin: 0;
        font-size: 30px;
        color: #fff;
        font-weight: bold;
        line-height: 30px;
        top: 0;
        display: block;
      }
    }
    &.multiselect--active {
      .multiselect__select {
        transform: none !important;
      }
    }
    .multiselect__tags {
      padding: 8px 122px 0 8px;
      border: 2px solid #dee1e3;
      min-height: 49px;
    }
    .multiselect__tags-wrap {
      display: inline-block;
      text-align: left;
    }
    .multiselect__tag {
      background-color: #000;
      padding: 8px 32px 8px 10px;
      margin-bottom: 8px;
      vertical-align: top;
      .multiselect__tag-icon {
        line-height: 32px;
        margin: 0 6px 0 0;
        &:after {
          color: #fff;
          font-size: 22px;
        }
        &:hover {
          background: none;
        }
      }
    }
  }
}
.invalid-field p.error-msg {
  padding: 5px 10px;
  background: #ffdada;
  border: 1px solid #ff0000;
}

</style>



// WEBPACK FOOTER //
// Create-model.vue?b183fd42